var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"title":"Update 2.25","size":"lg","hide-footer":""},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_vm._v(" ... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }